import React from "react";
import { 
  Container, 
  Card,
  CardContent,
  Box, 
  Skeleton,
  Tabs,
  Tab,
  Avatar,
  Grid
} from "@mui/material";

function UserProfilePageSkeleton() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      {/* Header with avatar */}
      <Box sx={{ 
        display: "flex", 
        alignItems: "center", 
        mb: 4, 
        p: 3,
        bgcolor: "background.paper",
        borderRadius: 1
      }}>
        <Skeleton variant="circular" width={80} height={80} sx={{ mr: 3 }} />
        <Box>
          <Skeleton variant="text" width={200} height={36} sx={{ mb: 1 }} />
          <Skeleton variant="text" width={150} height={24} />
        </Box>
      </Box>

      {/* Tabs skeleton */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Box sx={{ display: "flex", gap: 3 }}>
          <Skeleton variant="rectangular" width={120} height={48} />
          <Skeleton variant="rectangular" width={120} height={48} />
          <Skeleton variant="rectangular" width={120} height={48} />
        </Box>
      </Box>

      {/* Content area */}
      <Card>
        <CardContent sx={{ p: 4 }}>
          {/* Profile form skeleton */}
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Box sx={{ mb: 3 }}>
                <Skeleton variant="text" width={100} height={24} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={56} />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ mb: 3 }}>
                <Skeleton variant="text" width={80} height={24} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={56} />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ mb: 3 }}>
                <Skeleton variant="text" width={120} height={24} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={56} />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ mb: 3 }}>
                <Skeleton variant="text" width={90} height={24} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={56} />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ mb: 3 }}>
                <Skeleton variant="text" width={150} height={24} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={120} />
              </Box>
            </Grid>
          </Grid>

          {/* Avatar upload section */}
          <Box sx={{ mt: 4, mb: 3 }}>
            <Skeleton variant="text" width={150} height={24} sx={{ mb: 2 }} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Skeleton variant="circular" width={60} height={60} />
              <Box>
                <Skeleton variant="rectangular" width={120} height={36} sx={{ mb: 1 }} />
                <Skeleton variant="text" width={200} height={16} />
              </Box>
            </Box>
          </Box>

          {/* Action buttons */}
          <Box sx={{ 
            display: "flex", 
            gap: 2, 
            justifyContent: "flex-end",
            mt: 4 
          }}>
            <Skeleton variant="rectangular" width={100} height={48} />
            <Skeleton variant="rectangular" width={120} height={48} />
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}

export default UserProfilePageSkeleton;